module.exports = __webpack_public_path__ + "img/Gananms.1933a0c1.png";